// extracted by mini-css-extract-plugin
export default {"root":"MenuNameWin98_root__2+6zG"};